// RadioGroup.jsx
import React from 'react';

export function RadioGroup({ children, value, onValueChange, className = '' }) {
  return (
    <div className={className}>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child;

        return React.cloneElement(child, {
          checked: child.props.value === value,
          onChange: onValueChange,
        });
      })}
    </div>
  );
}


// RadioGroupItem.jsx
export function RadioGroupItem({ value, id, checked, onChange, children }) {
  return (
    <div className="flex items-center gap-2">
      <input
        type="radio"
        id={id}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        className="accent-blue-600"
      />
      <label htmlFor={id}>{children}</label>
    </div>
  );
}
